import TheGrid from '@/views/products/prodaggregs/grid'
import Edit from '@/views/products/prodaggregs/edit'

export default {
  path: '/products/prodaggregs',
  redirect: '/products/prodaggregs/index',
  name: 'prodaggregs',
  meta: {
    auth: {
      redirect: {
        name: 'prodaggregs.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Produtos'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'prodaggregs.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'prodaggregs.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'prodaggregs.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
